import React from 'react';
import Footer2Component from '../commons/footer2';
import MenuComponent from '../commons/menu';

import {IndexLink, Link, withRouter} from 'react-router';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import axios from 'axios';
var querystring = require('querystring');
import ReactGA from 'react-ga';
import {isMobile} from 'react-device-detect';

class EDemo4Page extends React.Component { //talent/contact-us
    constructor(props) {
        super(props);

        this.state = {
            first_name_lead: '',
            last_name_lead: '',
            company_name_lead: '',
            email_name_lead: '',
            phone_name_lead: '',
            state_name_lead: '',
            role_name_lead: '',
            locOptions: [],
            roleOptions: [],
            errors: {}
        }

        // Add your tracking ID created from https://analytics.google.com/analytics/web/#home/
        ReactGA.initialize('UA-122650632-1');
        // This just needs to be called once since we have no routes in this case.
        ReactGA.pageview(window.location.pathname);
    }
	
	componentDidMount() {
		this.getRoleOptions();
	}

    getLocationOptions(input, callback) {
        if(input.length == 0)
        {
            callback(null, { options: this.state.locOptions });
        }
        else {
            var data = new FormData();
            data.append('search', input);
            axios.post('/code/apis.php?api=searchJobLocation', data, {
                progress: (progressEvent) => {}
            })
                .then(response => {
                    if (response.data.status == 1) {
                        callback(null, { options: response.data.data });
                    } else {
                        callback(null, { options: [] });
                    }
                    return response;
                })
                .catch(error => {
                    callback(null, { options: [] });
                });
        }
    }

    getRoleOptions() {
        var data = new FormData();
		data.append('search', '');
		axios.post('/code/apis.php?api=getParams&opt_param=d_role&opt_lable=true', data, {
			progress: (progressEvent) => {}
		})
			.then(response => {
				if (response.data.status == 1) {
					this.setState({roleOptions: response.data.data});
				} 
				return response;
			})
			.catch(error => {
				
			});
    }

    handleChange (field, event) {
        let profile = this.state;
        if (field == 'state_name_lead' || field == 'role_name_lead') {
            profile[field] = event.value;
        }
        else {
            profile[field] = event.target.value;
        }
        this.setState(Object.assign({}, profile));
    }

    handleSubmit (event) {
		let params = this.state;
        let hasErrors = false;
        let errors = {};
        if (params.first_name_lead == '') {
            hasErrors = true;
            errors['first_name_lead'] = 'Required';
        }
        if (params.last_name_lead == '') {
            hasErrors = true;
            errors['last_name_lead'] = 'Required';
        }
        if (params.company_name_lead == '') {
            hasErrors = true;
            errors['company_name_lead'] = 'Required';
        }
        if (params.email_name_lead == '') {
            hasErrors = true;
            errors['email_name_lead'] = 'Required';
        }
        if (params.phone_name_lead == '') {
            hasErrors = true;
            errors['phone_name_lead'] = 'Required';
        }
        if (params.state_name_lead == '') {
            hasErrors = true;
            errors['state_name_lead'] = 'Required';
        }
        if (params.role_name_lead == '') {
            hasErrors = true;
            errors['role_name_lead'] = 'Required';
        }

        this.setState({errors: errors});

        if (hasErrors == false) {
            axios.post('/code/api_gstarts.php?api=insLead&demo=5', querystring.stringify(params)) //#5 is contact of coupon
                .then(response => {
                    if (response.data.status == 1) {
                        window.location = "/home";
                    }

                    return response;
                });
        }
    }

    render() {
        return (
            <div>
                <div className="advertise_boxs" id={"d_welcome"}>
                    <div className={"block-001"}>
                        <Link to="/business"><img className={isMobile?"m_img_logo":"img_logo"} src="/static/img/appimg/h_logo.png"/></Link>
                        {isMobile?
                            <MenuComponent is_hide={3}/>
                            :
                            <Link className="btn_login" to="/signin">Sign in</Link>
                        }
                    </div>
                    <div className={"block-003 clear"}>
                        <div className={"item-00"}>
                            <p className={"text-center item-011"}>&nbsp;</p>
                            <p className={"text-center item-01"}>Thank you for your request!</p>
                            <p className={"text-center"}>Your ad credits will arrive within the next business day.</p>
                        </div>
                        <p className={"text-center item-02"}>Want to learn more about Versity's marketing platform? Speak with an expert today.</p>
                    </div>
                    <div className={isMobile?"block-002 mobile":"block-002"}>
                        <div className={"left"}>
                            <p>&nbsp;</p>
                            <ul>
                                <li><span>Tell your unique company story by giving Millennial and Gen Z candidates a view into your culture and careers.</span></li>
                                <li><span>Hire students and recent graduates from from one-, two-, and four-year colleges and universities.</span></li>
                                <li><span>Target by school, major, year of graduation, GPA, languages, or diversity.</span></li>
                            </ul>
                            <p>Schedule a live demo of Versity today.</p>
                            <small><span className="glyphicon glyphicon-earphone" aria-hidden="true"></span> Contact sales: <a href="tel:1-877-837-7489">1-877-837-7489</a></small>
                        </div>
                        <div className={"right"}>
                            {isMobile?"":<p>&nbsp;</p>}
                            <input
                                value={this.state.first_name_lead}
                                onChange={this.handleChange.bind(this, 'first_name_lead')}
                                className="form-controls"
                                type="text"
                                placeholder="First Name *"
                            />
                            {this.state.errors.first_name_lead ? <p className={'cls-error'}>{this.state.errors.first_name_lead}</p> : '' }
                            <input
                                className="form-controls"
                                type="text"
                                placeholder="Last Name *"
                                value={this.state.last_name_lead}
                                onChange={this.handleChange.bind(this, 'last_name_lead')}
                            />
                            {this.state.errors.last_name_lead ? <p className={'cls-error'}>{this.state.errors.last_name_lead}</p> : '' }
                            <input
                                className="form-controls"
                                type="text"
                                placeholder="Company *"
                                value={this.state.company_name_lead}
                                onChange={this.handleChange.bind(this, 'company_name_lead')}
                            />
                            {this.state.errors.company_name_lead ? <p className={'cls-error'}>{this.state.errors.company_name_lead}</p> : '' }
                            <input
                                className="form-controls"
                                type="text"
                                placeholder="Email *"
                                value={this.state.email_name_lead}
                                onChange={this.handleChange.bind(this, 'email_name_lead')}
                            />
                            {this.state.errors.email_name_lead ? <p className={'cls-error'}>{this.state.errors.email_name_lead}</p> : '' }
                            <input
                                className="form-controls"
                                type="text"
                                placeholder="Phone Number *"
                                value={this.state.phone_name_lead}
                                onChange={this.handleChange.bind(this, 'phone_name_lead')}
                            />
                            {this.state.errors.phone_name_lead ? <p className={'cls-error'}>{this.state.errors.phone_name_lead}</p> : '' }
                            <div className="edit_item">
                                <div className="title">City State</div>
                                <Select.Async
                                    name="job_function"
                                    className="select_box"
                                    placeholder={"Search City/State*"}
                                    value={this.state.state_name_lead}
                                    options={this.state.locOptions}
                                    onChange={this.handleChange.bind(this, 'state_name_lead')}
                                    loadOptions={this.getLocationOptions.bind(this)}
                                    clearable={false}
                                    searchable={true}
                                />
                            </div>
                            {this.state.errors.state_name_lead ? <p className={'cls-error'}>{this.state.errors.state_name_lead}</p> : '' }
                            <div className="edit_item">
                                <Select.Async
                                    name="job_function"
                                    className="select_box"
                                    placeholder={"Your role *"}
                                    value={this.state.role_name_lead}
                                    options={this.state.roleOptions}
                                    onChange={this.handleChange.bind(this, 'role_name_lead')}
                                    //loadOptions={this.getRoleOptions.bind(this)}
                                    clearable={false}
                                    searchable={true}
                                />
                            </div>
                            {this.state.errors.role_name_lead ? <p className={'cls-error'}>{this.state.errors.role_name_lead}</p> : '' }
                            <p>By submitting this form, you agree that we may use the data you provide to contact you with information related to your request/submission and the relevant Versity product. If you are a Versity member, you can control the messages you receive from Versity in your settings. If you are a guest, you can unsubscribe from Versity marketing emails at any time by clicking the unsubscribe link in the email. To learn more, see Versity's <Link to={"/privacy"}>Privacy Settings</Link>.</p>
                            <p>&nbsp;</p>
                            <p>&nbsp;</p>
                            <p>&nbsp;</p>
                            <a className={"submit"} onClick={this.handleSubmit.bind(this)}>Submit</a>
                            <span className={"req"}>Required fields *</span>
                        </div>
						<div className={"clear"}></div>
                    </div>
                </div>
                <div className={"txtCenter"}>
                    <Footer2Component/>
                </div>
            </div>
        )
    }
}
EDemo4Page.propTypes = {
    router: React.PropTypes.shape({
        push: React.PropTypes.func.isRequired
    }).isRequired
};

export default (withRouter(EDemo4Page));


/** WEBPACK FOOTER **
 ** ./src/client/app/homecomponents/pages/edemo4.js
 **/